import { LinkButton } from '@/components/Buttons/LinkButton';
import { CardBlock } from '@/components/CardBlock';
import { FlashlightCursorWrapper } from '@/components/FlashlightCursorWrapper';

export const NewEra = () => {
  return (
    <div className="new-era-container">
      <h1>OUR WAYS OF DOING THINGS</h1>
      <div className="container card-container">
        <div className="card-column">
          <FlashlightCursorWrapper className="card">
            <h3>Decentralisation</h3>
            <p>
              We are a remote team of Web3 natives from all four corners of the
              globe, utilising blockchain technology in all we do.
            </p>
          </FlashlightCursorWrapper>
          <FlashlightCursorWrapper className="card">
            <h3>Transparency</h3>
            <p>
              We display key ecosystem metrics that highlight our performance to
              increase transparency.
            </p>
            {/*<p className="link link-button"> Coming soon </p>*/}
          </FlashlightCursorWrapper>
        </div>
        <div className="card-column extra-space">
          <FlashlightCursorWrapper className="card">
            <h3>Governance</h3>
            <p>
              Our ecosystem, products and vision is shaped by XBG holders
              through voting mechanisms.
            </p>
          </FlashlightCursorWrapper>
          <FlashlightCursorWrapper className="card">
            <h3>Ownership</h3>
            <p>
              From an early stage, we’ve given players an opportunity to invest
              in XBorg and other promising gaming projects.
            </p>
          </FlashlightCursorWrapper>
        </div>
      </div>
    </div>
  );
};
